export class TypedObject {
  static entries<T extends Record<string, any>>(obj: T): Array<[keyof T, T[keyof T]]> {
    return Object.entries(obj) as Array<[keyof T, T[keyof T]]>;
  }

  static keys<T extends Record<string, any>>(obj: T): Array<keyof T> {
    return Object.keys(obj) as Array<keyof T>;
  }
}
